import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import moment from "moment";
import { ManualAutoButton } from "@/shared/components/ManualAutoButton";
import { CategoryTag } from "../../shared/components/CategoryTag";
import { GridButtons } from "../components/others/GridButtons";
import { DelayByShift } from "../models/DelayByShift";

type Props = {
	justifyData: (delay: DelayByShift) => void;
	splitData: (delay: DelayByShift) => void;
	showContextMenu: Function;
};

export const useTableData = ({
	justifyData,
	splitData,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "Start",
			headerName: "Start",
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.Start, "MM/dd - HH:mm:ss") || "",
			flex: 1,
			sortable: true,
			minWidth: 164,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.End, "MM/dd - HH:mm:ss") || "",
			flex: 1,
			sortable: true,
			minWidth: 164,
		},
		{
			field: "AssetName",
			headerName: "Line",
			valueGetter: (params) => params.data?.AssetName || "",
			flex: 1,
			sortable: true,
			minWidth: 80,
			maxWidth: 100,
		},
		{
			field: "Duration",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value) {
					const duration = moment.duration(params.value, "seconds");
					const minutes = Math.floor(duration.asMinutes());
					const seconds = duration.seconds();

					const formattedMinutes = String(minutes).padStart(2, "0");
					const formattedSeconds = String(seconds).padStart(2, "0");

					return `${formattedMinutes}m ${formattedSeconds}s`;
				}
				return "";
			},
			flex: 1,
			sortable: true,
			minWidth: 85,
		},
		{
			field: "DelayCategory",
			headerName: "Category",
			valueGetter: (params) => {
				const delayCategoryName = params.data?.DelayCategoryName;
				const delayCategoryColor = params.data?.DelayCategoryColor;
				return { name: delayCategoryName, color: delayCategoryColor };
			},
			cellRenderer: CategoryTag,
			flex: 2,
			minWidth: 140,
			maxWidth: 140,
		},
		{
			field: "DelayCodePath",
			headerName: "Code",
			flex: 3,
			cellStyle: {
				textAlign: "left",
			},
			wrapText: true,
			minWidth: 300,
		},
		{
			field: "Comments",
			headerName: "Comments",
			flex: 4,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
			minWidth: 89,
		},
		{
			field: "JustifiedByUser",
			headerName: "User",
			flex: 1,
			sortable: true,
			minWidth: 70,
		},
		{
			field: "JustifiedDatetime",
			headerName: "Justification Date",
			wrapHeaderText: true,
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.JustifiedDatetime, "MM/dd - HH:mm"),
			flex: 2,
			minWidth: 112,
		},
		{
			field: "IsManual",
			headerName: "",
			cellRenderer: (params: ICellRendererParams) =>
				ManualAutoButton({ isManual: params.value, tooltip: "Manual Delay" }),
			width: 50,
			maxWidth: 50,
			minWidth: 50,
			sortable: false,
			suppressHeaderMenuButton: true,
		},
		{
			field: "",
			headerName: "actions",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				data: params.data,
				justifyData: justifyData,
				splitData: splitData,
				showContextMenu: () =>
					showContextMenu(event, params.data, "delayManagerContext"),
			}),

			flex: 1,
			maxWidth: 180,
			minWidth: 180,
		},
	];
	return { columnDefs };
};
